<template>

  <div class="home">
    <Navbar :is-active="4"></Navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
          <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>{{company_name}}</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/Client/ic-operativo-contable" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-briefcase"></i>
            </div>
            <div class="tab__text">
              <p>Operativo - contable</p>
            </div>
          </router-link>
          <router-link to="" class="tab">
            <div class="tab__icon">
              <i class="fas fa-calculator"></i>
            </div>
            <div class="tab__text">
              <p>Contable</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Incidencia</h2>
        </div>
        <div class="page__subtitle">
          <h3>Información del Inicidencia</h3>
        </div>
        <section class="page__filters">
          <div class="input" style="background: #e7e7e7;">
            <p>Código de Incidencia</p>
            <span>{{ codeFormat(id) }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Fecha de Registro</p>
            <span>{{ dateFormat(created_at) }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Nombre</p>
            <span>{{ user_name }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Apellido</p>
            <span>{{ user_lastname }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Numero de documento</p>
            <span>{{ user_doc_number }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Estado</p>
            <span>{{ estado }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Comentario</p>
            <span>{{ incidence_comment }}</span>
          </div>
        </section>

        <div class="page__subtitle" style="margin-top: 2rem;">
          <h3>Documento de la incidencia</h3>
        </div>
        <section class="page__product">
          <div class="product__image">
            <img :src="imagen" alt="Subir incidencia" v-if="imagen">
          </div>
        </section>
        <div class="page__filters">
          <div class="input" >
            <p>Resolución</p>
            <input type="text" v-model="incidence_resolution">
          </div>
        </div>
        <section class="page__actions">
          <button @click="exitProduct()">
            <span>Cancelar</span>
            <i class="fa fa-times-circle"></i>
          </button>
          <button @click="saveProduct()">
            <span>Guardar</span>
            <i class="fa fa-circle-check"></i>
          </button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "../components/NavBar";
import axios from "axios";
import OpenArrow from '@/components/OpenArrow.vue'
import HiddenArrow from '@/components/HiddenArrow.vue'
import { dateFormat } from '@/utils/formats'
import { codeFormat } from '@/utils/formats'

export default {
  name: 'ShowOperativoContable',
  components: {
    Navbar,
    OpenArrow,
    HiddenArrow,
  },
  data() {
    return {
      incidence: null,
      f_registro: '',
      f_update: '',
      product_code: '',
      product_barcode: '',
      product_name: '',
      product_type_id: '',
      product_brand_id: '',
      product_price: '',
      product_discout_bf: '',
      product_discout: '',
      product_descripcion: '',
      file: null,
      imagen: '',
      created_at:'',
      id: '',
      estado:'',
      incidence_comment:'',
      incidence_file: '',
      incidence_resolution: '',
      respuesta: '',
      user_doc_number: '',
      user_lastname: '',
      user_name: '',
      status: 2,
      imagen_default:         location.protocol +
        "//" +
        location.host +
        "/default/default_product.jpg",
      tableHmtl: "",
    }
  },
  mounted() {
    this.company_name = localStorage.getItem('company_name');
    try {
      const val = window.location.search;
      const urlParams = new URLSearchParams(val);
      var id = urlParams.get('id');

      let result = axios
          .get("general/incidence/detail/"+id)
          .then(res => {
            this.incidence = res.data.data;
            this.id = res.data.data.id
            this.created_at=res.data.data.created_at;
            this.estado=res.data.data.estado;
            this.incidence_comment=res.data.data.incidence_comment;
            this.incidence_file= res.data.data.incidence_file;
            this.incidence_resolution= res.data.data.incidence_resolution;
            this.respuesta= res.data.data.respuesta;
            this.user_doc_number= res.data.data.user_doc_number;
            this.user_lastname= res.data.data.user_lastname;
            this.user_name= res.data.data.user_name;
            this.imagen = res.data.data.incidence_file
          })
    }catch (error){
      console.log(error)
      this.$router.push('/');
    }
  },
  methods:{
    codeFormat,
    dateFormat,
    change_file(event){
      this.file = event.target.files[0]
      let reader = new FileReader()
      if (event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpeg' || vent.target.files[0].type === 'image/jpg' ) {
        reader.onload = (e) => {
          this.imagen = e.target.result
        }
      } else {
        this.$swal({
          position: 'top-end',
          icon: 'error',
          title: 'El archivo no es un formato de imagen',
          showConfirmButton: false,
          timer: 2000
        })
      }
      reader.readAsDataURL(this.file)
    },
    async saveProduct(){
      try {
        const val = window.location.search;
        const urlParams = new URLSearchParams(val);
        var id = urlParams.get('id');
        const formData = new FormData();
        formData.append("incidence_resolution", this.incidence_resolution);
        formData.append("file", this.file);
        formData.append("incidence_status", this.status)

        const response = await axios.post('general/incidence/'+ id, formData);
        if((await response).status === 200){
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'comentario actualizado correctamente',
            showConfirmButton: false,
            timer: 2000
          })
          this.$router.push('/Client/ic-operativo-contable')
        }
      } catch (error) {
        console.log(error)
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'No se pudo actualizar comentario',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    exitProduct(){
      this.$router.push('/Client/ic-operativo-contable')
    }
  },
}


</script>

<style scoped>
#input_file {
  cursor: pointer;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
}
/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul{
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
  width: 20%;
}
.home .navbar__right .profile {
  display: flex;
  width: 100%;
  height: 100%;
}

.home .navbar__right .profile__detail{
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
a:hover {
  text-decoration: none;
}
/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;
}
.body__sidebar,
.body__containt  {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 30px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
  margin: 0;
  font-weight: 600;
}
/*----------------------------*/
/*----------------------------*/
/*----------------------------*/
.body__containt {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  overflow-y: scroll;
}
.body__containt .page__subtitle,
.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #000;
  font-size: 25px;
}
.body__containt .page__title h2 span {
  color: #ff3128;
}
.body__containt .page__subtitle h3  {
  color: #ff3128;
  font-weight: 600;
  font-size: 20px;
}

/*-----FILTERS------*/

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 0px;
}

.body__containt .page__filters .input {
  width: 300px;
  border-radius: 10px;
  border: 1px solid #938f8f;
  display: flex;
  flex-direction: column;
  padding: 7px 15px;
  transition: 0.4s ease;
}

.body__containt .page__filters .input:hover {
  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.05);
}
.body__containt .page__filters .input:nth-last-child(1) {
  width: 1260px;
}
.body__containt .page__filters .input span {
  font-size: 15px;
  color: #938f8f;
}
.body__containt .page__filters .input p {
  margin: 0;
}

.page__filters input, select, textarea{
  outline:none;
  border: none;
  background: white;
}

/*-----PRODUCT------*/
.page__product {
  width: 100%;
  display: flex;
  padding-bottom: 50px;
}

.page__product .product__image,
.page__product .product__buttons {
  /* width: 50%; */
  display: flex;
  align-items: center;
}
.page__product .product__image {
  width: 400px;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.page__product .product__image img {
  width: 100%;
  object-fit: cover;
  transition: 1s ease;
}
.page__product .product__image img:hover {
  transform: scale(1.1) rotate(1deg);
}
.page__product .product__buttons {
  width: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.page__actions button,
.page__product .product__buttons button {
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.page__actions button:hover,
.page__product .product__buttons button:hover {
  transform: scale(1.1);
}
.page__actions button:nth-child(2),
.page__product .product__buttons button:nth-child(1) {
  background: #32ba7c;
}
.page__product .product__buttons button:nth-child(2) {
  background: #262626;
}
.page__product .product__buttons button:hover:nth-child(2) {
  background: #ff3128;
}

/*------------------------*/
/*------------------------*/
/*------------------------*/

.page__actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px 0;
  gap: 20px;
}

.page__actions button:nth-child(1) {
  background: #ff3128;
}

/*------BODY------*/
.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}
.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-evenly;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  white-space: nowrap;
}
.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
.lista_productos__buttons button{
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 20px;
  margin-bottom: 0px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 17px;
  left: 2px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
input:checked + .slider {
  background-color: #32ba7c;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.body__sidebar.open{
  display: none;
}
</style>
